<div class="modal fade task-modal-right profile-modal" [class.profile-modal--signature-open]="isEditingEmailSignature"
  bsModal id="OpenProfileModal"
  [config]="{ keyboard: false, backdrop: 'static' }" #openProfileModal="bs-modal" tabindex="-1">
  <div class="profile-redesign__wrapper" *ngIf="isActive">
    <div class="modal-dialog profile-redesign__dialog">
      <div class="modal-content profile-redesign">
        <header class="profile-redesign__header">
          <h2>My profile</h2>
          <button type="button" class="profile-redesign__icon-button" (click)="close()" aria-label="Close profile">
            <lucide-icon name="x" [size]="18" [strokeWidth]="2"></lucide-icon>
          </button>
        </header>

        <div class="profile-redesign__body">
          <section class="profile-redesign__identity" aria-label="Account identity">
            <span class="profile-redesign__avatar">
              <img *ngIf="imageSource" [src]="imageSource" [alt]="user.name">
              <span *ngIf="!imageSource">{{ initials }}</span>
            </span>
            <div class="profile-redesign__identity-copy">
              <strong>{{ user.name }} {{ user.surname }}</strong>
              <span>{{ user.jobTitle || 'No job title' }}</span>
            </div>
            <button type="button" class="profile-redesign__secondary-button" (click)="syncProfilePic()">
              <lucide-icon name="refresh-cw" [size]="15" [strokeWidth]="2"></lucide-icon>
              Sync M365 photo
            </button>
          </section>

          <form #profileForm="ngForm" name="userForm" novalidate autocomplete="off">
            <div class="profile-redesign__band">Personal information</div>

            <div class="profile-redesign__row">
              <span class="profile-redesign__label">
                <lucide-icon name="user" [size]="15" [strokeWidth]="2"></lucide-icon>
                Name
              </span>
              <span class="profile-redesign__value">{{ user.name }} {{ user.surname }}</span>
              <span class="profile-redesign__managed">
                <lucide-icon name="lock" [size]="13" [strokeWidth]="2"></lucide-icon>
                Managed by Microsoft 365
              </span>
            </div>

            <div class="profile-redesign__row">
              <span class="profile-redesign__label">
                <lucide-icon name="briefcase" [size]="15" [strokeWidth]="2"></lucide-icon>
                Job title
              </span>
              <span class="profile-redesign__value">{{ user.jobTitle || '—' }}</span>
              <span class="profile-redesign__managed">
                <lucide-icon name="lock" [size]="13" [strokeWidth]="2"></lucide-icon>
                Managed by Microsoft 365
              </span>
            </div>

            <div class="profile-redesign__row profile-redesign__row--time-zone">
              <span class="profile-redesign__label">
                <lucide-icon name="clock" [size]="15" [strokeWidth]="2"></lucide-icon>
                Time zone
              </span>
              <span class="profile-redesign__value" *ngIf="!isEditingTimeZone">{{ timeZoneDisplay }}</span>
              <div class="profile-redesign__time-zone-editor" *ngIf="isEditingTimeZone">
                <select class="profile-redesign__time-zone-select" name="timeZoneId"
                  [(ngModel)]="selectedTimeZoneId" [disabled]="isTimeZoneSaving" aria-label="Time zone">
                  <option *ngFor="let timeZone of allTimezones; trackBy: trackByLookupOption" [ngValue]="timeZone.id">
                    {{ timeZone.name }}
                  </option>
                </select>
                <button type="button" class="profile-redesign__text-button" (click)="cancelTimeZoneEdit()"
                  [disabled]="isTimeZoneSaving">Cancel</button>
                <button type="button" class="profile-redesign__secondary-button" (click)="saveTimeZone()"
                  [disabled]="isTimeZoneSaving || !selectedTimeZoneId">
                  {{ isTimeZoneSaving ? 'Saving…' : 'Save' }}
                </button>
              </div>
              <button type="button" class="profile-redesign__secondary-button" *ngIf="!isEditingTimeZone"
                (click)="beginTimeZoneEdit()">Change</button>
            </div>

            <div class="profile-redesign__band profile-redesign__band--bordered">Email</div>

            <div class="profile-redesign__row">
              <span class="profile-redesign__label">
                <lucide-icon name="mail" [size]="15" [strokeWidth]="2"></lucide-icon>
                Email address
              </span>
              <span class="profile-redesign__value">{{ user.emailAddress | lowercase }}</span>
              <span class="profile-redesign__managed">
                <lucide-icon name="lock" [size]="13" [strokeWidth]="2"></lucide-icon>
                Managed by Microsoft 365
              </span>
            </div>
          </form>

          <section class="email-signature-section" *ngIf="emailSignatureFeatureEnabled"
            aria-labelledby="emailSignatureHeading">
            <div class="email-signature-section__heading-row">
              <h3 id="emailSignatureHeading" class="profile-redesign__label email-signature-section__label">
                <lucide-icon name="pencil-line" [size]="15" [strokeWidth]="2"></lucide-icon>
                Signature
              </h3>
              <button type="button" class="profile-redesign__secondary-button email-signature-section__edit"
                (click)="editEmailSignature()" *ngIf="hasEmailSignature" [disabled]="isEmailSignatureLoading">
                Edit
              </button>
            </div>

            <div class="email-signature-section__loading" *ngIf="isEmailSignatureLoading">
              Loading signature…
            </div>

            <div class="email-signature-section__empty" *ngIf="!isEmailSignatureLoading && !hasEmailSignature">
              <span class="email-signature-section__empty-icon" aria-hidden="true">
                <lucide-icon name="pencil-line" [size]="21" [strokeWidth]="1.8"></lucide-icon>
              </span>
              <span class="email-signature-section__empty-copy">
                <strong>Email signature</strong>
                <span>Create a professional signature for your client emails.</span>
              </span>
              <button type="button" class="email-signature-section__create" (click)="editEmailSignature()">
                Create signature
              </button>
            </div>

            <ng-container *ngIf="!isEmailSignatureLoading && hasEmailSignature">
              <div class="email-signature-section__preview">
                <vf-email-signature-preview [html]="emailSignatureHtml"></vf-email-signature-preview>
              </div>
            </ng-container>
          </section>
        </div>

        <vf-spinner *ngIf="isLoading"></vf-spinner>
      </div>
    </div>
  </div>

  <vf-email-signature-paste-dialog
    *ngIf="emailSignatureFeatureEnabled && isEditingEmailSignature"
    [value]="emailSignatureDraft"
    [saving]="isEmailSignatureSaving"
    (valueChange)="onEmailSignatureDraftChange($event)"
    (saveRequested)="saveEmailSignature()"
    (cancelRequested)="cancelEmailSignatureEdit()">
  </vf-email-signature-paste-dialog>
</div>
